import { Grid } from '@mantine/core'
import { NODE_STATUS_COLORS } from 'App/ServiceCenter/Map/_utils/getActiveNodeStatus'
import { ToggleSymbolValue } from 'App/ServiceCenter/ToggleSymbolValue/ToggleSymbolValue'
import type { TDnNodeLog, TNodeLog } from 'App/ServiceCenter/types'
import { renderWithDefaultValue } from 'App/ServiceCenter/utils/renderers'
import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'
import React from 'react'
import { useTimezoneForSelectedPropertyOrRegion } from '../../../../Map/PanelDetails/_utils/useTimezoneForSelectedPropertyOrRegion'

export const TrapLog: React.FC<{ log: TNodeLog }> = ({ log: lastLog }) => {
  const timezone = useTimezoneForSelectedPropertyOrRegion()

  if (!lastLog) return null

  const latestGoodPhoto = (lastLog as TDnNodeLog).latestGoodPhoto
  const latestGoodPhotoLabel = latestGoodPhoto && moment.tz(latestGoodPhoto, timezone).fromNow()

  return (
    <>
      <Grid.Col span={4}>{translate.phrases.placeholder('Last Good Photo')}</Grid.Col>
      <Grid.Col span={8}>
        {latestGoodPhoto ? (
          <span
            style={{
              color:
                latestGoodPhotoLabel?.includes('min') || latestGoodPhotoLabel?.includes('sec')
                  ? NODE_STATUS_COLORS.active
                  : 'black',
            }}
          >
            <ToggleSymbolValue value={moment.tz(latestGoodPhoto, timezone).format('lll z')}>
              {translate.phrases.placeholder(latestGoodPhotoLabel as string)}
            </ToggleSymbolValue>
          </span>
        ) : (
          translate.phrases.placeholder('-')
        )}
      </Grid.Col>

      <Grid.Col span={4}>{translate.phrases.placeholder('Image Count')}</Grid.Col>
      <Grid.Col span={8} css={{ fontWeight: 500 }}>
        {renderWithDefaultValue((lastLog as TDnNodeLog).imageCount)}
      </Grid.Col>
    </>
  )
}
